import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import {
	StatementArticle,
	StatementCategory,
	StatementCategoryDetails,
	StateStatementEntity,
} from '../../models/statements.models';
import * as StateStatementsActions from './statements.actions';

export const _STATE_STATEMENT_FEATURE_KEY = 'stateStatements';

export interface State extends EntityState<StateStatementEntity> {
	error: any;
	categories: StatementCategory[] | null;
	statements: StatementCategoryDetails | null;
	statement: StatementArticle | null;
	isLoading: boolean;
	categorySlug: string | null;
}

export const stateStatementAdapter: EntityAdapter<StateStatementEntity> =
	createEntityAdapter<StateStatementEntity>();

export const initialState: State = stateStatementAdapter.getInitialState({
	error: null,
	categories: null,
	statements: null,
	statement: null,
	isLoading: false,
	categorySlug: null,
});

const stateStatementsReducer = createReducer(
	initialState,
	on(StateStatementsActions.loadStatementsFailure, (state, { error }) => ({
		...state,
		error,
		isLoading: false,
		statements: null,
		statement: null,
		categorySlug: null,
	})),
	on(
		StateStatementsActions.fetchStatementCategories,
		StateStatementsActions.fetchStatementsByCategory,
		StateStatementsActions.fetchStatementArticle,
		(state) => ({
			...state,
			error: null,
			isLoading: true,
		}),
	),
	on(StateStatementsActions.updateStatementCategories, (state, { categories }) => ({
		...state,
		error: null,
		categories,
		isLoading: false,
	})),
	on(
		StateStatementsActions.updateStatementsForCategory,
		(state, { statements, categorySlug }) => ({
			...state,
			error: null,
			statements,
			categorySlug,
			isLoading: false,
		}),
	),
	on(StateStatementsActions.updateStatementArticle, (state, { statement }) => ({
		...state,
		error: null,
		statement,
		isLoading: false,
	})),
);

export function reducer(state: State | undefined, action: Action) {
	return stateStatementsReducer(state, action);
}
